import { IPayoutTransactionWithCharges, schemes, zSchema } from "@zeal/common";

export const getPayoutRequestSchema = zSchema.object({
  odo_user_id: schemes.mongoOrUuid(),
  payout_id: schemes.uuid().optional(),
});

export type TGetPayoutRequestSchema = zSchema.infer<
  typeof getPayoutRequestSchema
>;

export type TGetPayoutResponseSchema = IPayoutTransactionWithCharges[];
